import { useEffect, useState } from "react";
import { getDashboardSummary } from "../services/dashboardService";
import type { DashboardSummaryData } from "../types/dashboard.types";

export function useDashboardSummary() {
  const [summary, setSummary] = useState<DashboardSummaryData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getDashboardSummary()
      .then((res) => {
        if (cancelled) return;
        if (res.success && res.data != null) {
          setSummary(res.data);
        } else {
          setSummary(null);
          setError(res.message || "Could not load dashboard summary.");
        }
      })
      .catch(() => {
        if (!cancelled) {
          setSummary(null);
          setError("Could not load dashboard summary.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { summary, loading, error };
}
